export const l10nObjToSelectOptions = (l10nObj, format = true) => {
  if (format) {
    return Object.entries(l10nObj).map(([value, label]) => ({ label, value })) // Transform object into an array of objects with 'label' and 'value' properties
  } else {
    return [...l10nObj] // Return a copy of the input array
  }
}

export const getLang = () => document.documentElement.lang || 'de-DE'
